import { Document, SchemaField, FieldDataType } from '../models/document.model';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { BasicDocumentReader } from './basic-document-reader';
import { CultureService } from '../../services/culture.service';

export class DocumentReader extends BasicDocumentReader {
  constructor(public document: Document) {
    super(document);
  }

  public get dateCreated(): moment.Moment {
    const value = this.dateCreatedRawValue;
    return moment(value);
  }

  public get dateUpdated(): moment.Moment {
    const value = this.dateUpdatedRawValue;
    return moment(value);
  }

  public get posted(): moment.Moment {
    const value = this.postedRawValue;
    return !!value ? moment(value) : null;
  }

  public getFormattedFieldValue(name: string, schemaField: SchemaField, cultureService: CultureService): any {
    if (!this.document?.hasOwnProperty(name)) {
      return null;
    }
    const value = this.document[name];
    if (!value && value !== 0) {
      return null;
    }

    if (!schemaField) {
      return value;
    }

    if (schemaField.dataType === FieldDataType.DateTime) {
      return this.formatDate(value, schemaField?.settings?.format, cultureService);
    } else if (schemaField.dataType === FieldDataType.Number) {
      return this.formatNumber(value, schemaField?.settings?.format, cultureService);
    } else {
      return value;
    }
  }

  formatDate(value: string, format: string, cultureService: CultureService): string {
    if (!value) {
      return '';
    }

    if (!format) {
      format = 'LONG-DATE-WITH-TIME';
    }

    return cultureService.getDateDisplay(value, format);
  }

  formatNumber(value: any, format: string, cultureService: CultureService) {
    if (!value) {
      value = 0;
    }

    if (!format) {
      format = 'DECIMAL';
    }

    return cultureService.getNumberDisplay(value, format);
  }
}
